export const CAPermissionMap = new Map()

CAPermissionMap.set('CREATE_CM_CA', 'canCreateCA')
CAPermissionMap.set('CREATE_CM_CERTIFICATE', 'canCreateCertificate')
CAPermissionMap.set('MANAGE_CM_CA_CONFIGURATION', 'canManageCAConfiguration')
CAPermissionMap.set('MANAGE_CM_CA_CRL', 'canManageCACRL')
CAPermissionMap.set('MANAGE_CM_DOMAIN', 'canManageDomain')
CAPermissionMap.set('MANAGE_CM_HSM_CONFIGURATION', 'canManageHSMConfiguration')
CAPermissionMap.set('MANAGE_CM_SYSTEM_CA_CONFIGURATION', 'canManageSystemCAConfiguration')
CAPermissionMap.set('MANAGE_CM_SYSTEM_CRL_CONFIGURATION', 'canManageSystemCRLConfiguration')
CAPermissionMap.set('MANAGE_CM_SYSTEM_OCSP_CONFIGURATION', 'canManageSystemOCSPConfiguration')
CAPermissionMap.set('REVOKE_CM_CA', 'canRevokeCA')
CAPermissionMap.set('REVOKE_CM_CERTIFICATE', 'canRevokeCertificate')
CAPermissionMap.set('REVOKE_CM_CERTIFICATE', 'canViewAIAIssuer')
CAPermissionMap.set('VIEW_CM_CA', 'canViewCA')
CAPermissionMap.set('VIEW_CM_CA_CONFIGURATION', 'canViewCAConfiguration')
CAPermissionMap.set('VIEW_CM_CERTIFICATE', 'canViewCertificate')
CAPermissionMap.set('VIEW_CM_DOMAIN', 'canViewDomain')
CAPermissionMap.set('VIEW_CM_HSM_CONFIGURATION', 'canViewHSMConfiguration')
CAPermissionMap.set('VIEW_CM_HSM_PARTITIONS', 'canViewHSMPartitions')
CAPermissionMap.set('VIEW_CM_SYSTEM_CA_CONFIGURATION', 'canViewSystemCAConfiguration')
CAPermissionMap.set('VIEW_CM_SYSTEM_CRL_CONFIGURATION', 'canViewSystemCRLConfiguration')
CAPermissionMap.set('VIEW_CM_SYSTEM_OCSP_CONFIGURATION', 'canViewSystemOCSPConfiguration')
